<template>
    <div class="app-height overflow-hidden w-full flex flex-col bg-white font-gotham tracking-normal text-base">
        <promo-message v-if="specialMessage?.title" class="border-b border-gray w-full" />

        <div class="w-full flex-grow overflow-hidden flex flex-col lg:flex-row lg:justify-between">
            <product-header class="lg:hidden" />

            <product-renderer-wrapper class="relative flex-grow" />

            <step-options-wrapper
                :class="{ 'absolute right-0 transform translate-x-[500px]': isFullscreen }"
                class="order-1 lg:order-none lg:w-[492px] transition-transform duration-300 ease-out"
            />
        </div>

        <!-- Global popups -->
        <instance-error></instance-error>

        <not-available></not-available>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import PromoMessage from './PromoMessage.vue';
    import ProductHeader from './ProductHeader.vue';
    import ProductRendererWrapper from './ProductRendererWrapper.vue';
    import StepOptionsWrapper from './StepOptionsWrapper.vue';
    import InstanceError from './InstanceError.vue';
    import NotAvailable from './NotAvailable.vue';

    export default {
        mixins: [allStores],

        components: {
            PromoMessage,
            ProductHeader,
            ProductRendererWrapper,
            StepOptionsWrapper,
            InstanceError,
            NotAvailable,
        },

        computed: {
            isFullscreen() {
                return this.appStore.isFullscreen;
            },

            specialMessage() {
                return this.customizerStore.specialMessage;
            },
        },
    };
</script>
